const addcart = "/api/store/cart";//post添加购物车 get获取购物车 单个商品
const batchCart = "/api/store/batchCart";//post添加购物车 get获取购物车 多个商品[]
const getorders = "/api/store/orders";//get获取用用户订单
const deletecart = "/api/store/cart/";//删除商品
const changequantity = "/api/store/cart/";//PUT 修改商品数量
const batch_update = "api/store/cart/batch_update";//post  批量修改商品数量
const address = "/api/store/cart/address";//设置配送地址
const shipping_method = "/api/store/cart/shipping";//设置配送方式
const set_payment = "/api/store/cart/payment";//设置支付方式
const checkout = "/api/store/cart/checkout";//post生成订单
const setaddress = "/api/store/addresses";// POST添加地址S
const deleteaddress = "/api/store/addresses/";//DELETE 删除地址
const updateaddress = "/api/store/addresses/";//PUT 更新地址
const exchanges = "/api/store/exchanges" //GET获取税率
const testdiscount = "/api/store/cart/coupons" //post添加优惠券
const deletediscount = "/api/store/cart/coupons/" //delete删除优惠券
const checkDiscount = "/api/store/cart/checkoutCoupons" // get 地址校验时校验优惠券
const start_checkout = "/api/store/cart/start_checkout" //post 快速结账
const subscribe = "/api/contacts" //post 订阅邮箱
const statis_event = "/api/statistics/events" //post 分享统计
const auto_complete = "/api/store/place-auto-complete" //post 自动填充
const comment_attachments = "/api/store/attachments" //图片上传
const last_sales = "/api/store/last-sales" //最近购买记录
const ipinfo = "/api/store/ip" //获取ip信息
const worldpay = "https://api.worldpay.com/v1/tokens" //获取ip信息
const getPolicy = "/api/store/policies" //get获取单个政策条款
const track = "/api/store/trackhub" //get获取物流消息
const cart_note = "/api/store/cart/note" //post 设置购物车备注
const popups = "/api/store/popups" //post ID/view 浏览弹窗 ID/subscription 订阅弹窗
const report = "/api/store/report" //report dmca举报
const get_coupons = "/api/store/coupons/" //get 获取商品优惠活动
const get_code_display = "/api/store/code_display/"
const incentives = "/api/store/incentives/"
const incentives_share="/api/store/incentives/share" // post 分享统计
const custom_button="/api/store/get_buttons/" // get 获取自定义按钮
const click_button="/api/store/click_button" // get 获取自定义按钮
const palette="/api/store/product_palettes/" //
const products="/api/store/products"
const visitors_counter="/api/store/visitors_counter/"
const contact_page = "/api/store/contact_service" // post 发送联系我们邮件
const categories = "/api/store/categories/"
const product_card = "/api/store/product_cards" // get 获取产品卡片标签
const get_instagram = "/api/store/instagram/posts" // get 获取ins帖子
const order_tracking = "/api/store/order-tracking/logistics" // get 获取产品卡片标签
const style_combination = "/api/store/style-combinations" // get 获取款式组合
const prescriptions = "/api/store/fclca/prescriptions" // post 创建处方信息
const prescriptions_attachments = "/api/store/fclca/prescriptions/attachments" // post 上传处方图片
const privacy_policy = "/api/store/privacy_managements" // get 隐私政策

export default {
    batchCart,
    addcart,
    deletecart,
    changequantity,
    address,
    shipping_method,
    set_payment,
    checkout,
    setaddress,
    deleteaddress,
    updateaddress,
    exchanges,
    testdiscount,
    deletediscount,
    checkDiscount,
    start_checkout,
    subscribe,
    statis_event,
    auto_complete,
    comment_attachments,
    batch_update,
    getorders,
    last_sales,
    ipinfo,
    worldpay,
    getPolicy,
    track,
    cart_note,
    report,
    get_coupons,
    popups,
    get_code_display,
    incentives,
    incentives_share,
    custom_button,
    click_button,
    palette,
    products,
    visitors_counter,
    contact_page,
    categories,
    product_card,
    get_instagram,
    order_tracking,
    style_combination,
    prescriptions,
    prescriptions_attachments,
    privacy_policy,
}
